import httpCommonReclu from "../http-common-reclu";

class CarnetService {

    merge(data) {
        return httpCommonReclu.post("/v1/documentos/merge", data);
    }
}

export default new CarnetService();